import { render, staticRenderFns } from "./ProductModalDescriptionComponent.html?vue&type=template&id=3ceac6ee&scoped=true&"
import script from "./ProductModalDescriptionComponent.js?vue&type=script&lang=js&"
export * from "./ProductModalDescriptionComponent.js?vue&type=script&lang=js&"
import style0 from "./ProductModalDescriptionComponent.scss?vue&type=style&index=0&id=3ceac6ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceac6ee",
  null
  
)

export default component.exports